import React, { memo } from 'react';

import HighlightColumn from '../Table/Decorator/HighlightColumn';
import Loading from '../../General/Loading';
import Table from '../Table/Table';
import { ExportPdf } from '../Pdf/ExportPdf';

import InterestUri from '../../../Enum/InterestUri';

import getHighlightedColumnNumber from '../../../Reducer/GetHighlightedColumnNumber';
import useGetSort from '../../../Hook/Interest/UseGetSort';
import useGetBridgingLoans from '../../../Hook/Interest/BridgingLoan/UseGetBridgingLoans';
import useIsFilterLoading from '../../../Hook/Interest/UseIsFilterLoading';
import useGetFilteredValues from '../../../Hook/Interest/UseGetFilteredValues';

const BridgingLoanTable: React.FC = () => {
    const { bridgingLoanLabels } = useGetFilteredValues();
    const currentSort = useGetSort(InterestUri.BridgingLoan);
    const isFilterLoading = useIsFilterLoading();
    const { error, data, headers, loading } = useGetBridgingLoans(bridgingLoanLabels);

    if (loading || isFilterLoading) {
        return <Loading />;
    }

    if (error || !data.length || !headers.length) {
        return <p className="no-results">Geen resultaten gevonden, pas uw filters aan.</p>;
    }

    const highlightedColumnNO = getHighlightedColumnNumber(currentSort.prop, headers);
    return (
        <>
            {highlightedColumnNO > 0 && <HighlightColumn column={highlightedColumnNO} />}
            <ExportPdf headers={headers}
                       rows={data}
                       section={InterestUri.BridgingLoan}
                       sort={currentSort} />
            <Table
                className="bridging-loan-table"
                data={data}
                headers={headers}
                section={InterestUri.BridgingLoan}
                sort={currentSort}
            />
        </>
    );
};

export default memo(BridgingLoanTable);
